exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-center {\n  text-align: center;\n}\n\n.top-row {\n  margin-bottom: 20px;\n}\n\n.select-row {\n  margin-bottom: 20px;\n}\n\n.modal-body {\n  max-height: 300px;\n  overflow: auto;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/dynamic-tips/tree-view/modal-edit-node/modal-edit-node.component.css
// module id = ../../../../../src/app/modules/dynamic-tips/tree-view/modal-edit-node/modal-edit-node.component.css
// module chunks = main